import { api } from "../../api/apiSlice";

export const designationsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDesignations: builder.query({
      query: () => ({ url: "/designations" }),
      providesTags: (result) =>
        result
          ? [
              ...result.map((d) => ({
                type: "Designations",
                id: d.designationId,
              })),
              { type: "Designations", id: "LIST" },
            ]
          : [{ type: "Designations", id: "LIST" }],
    }),
    getDesignation: builder.query({
      query: (designationId) => ({ url: `/designations/${designationId}` }),
      providesTags: (result, error, designationId) => [
        { type: "Designations", id: designationId },
      ],
    }),
    createDesignation: builder.mutation({
      query: (body) => ({ url: "/designations", method: "POST", data: body }),
      invalidatesTags: [{ type: "Designations", id: "LIST" }],
    }),
    renameDesignation: builder.mutation({
      query: ({ designationId, designationName }) => ({
        url: `/designations/${designationId}`,
        method: "PUT",
        data: { designationName },
      }),
      invalidatesTags: (result, error, { designationId }) => [
        { type: "Designations", id: designationId },
        { type: "Designations", id: "LIST" },
      ],
    }),
    deleteDesignation: builder.mutation({
      query: (designationId) => ({
        url: `/designations/${designationId}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Designations", id: "LIST" }],
    }),
    assignDesignationPermission: builder.mutation({
      query: ({ designationId, permissionId }) => ({
        url: `/designations/${designationId}/permissions/${permissionId}`,
        method: "POST",
      }),
      invalidatesTags: (result, error, { designationId }) => [
        { type: "Designations", id: designationId },
      ],
    }),
    removeDesignationPermission: builder.mutation({
      query: ({ designationId, permissionId }) => ({
        url: `/designations/${designationId}/permissions/${permissionId}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, { designationId }) => [
        { type: "Designations", id: designationId },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetDesignationsQuery,
  useGetDesignationQuery,
  useCreateDesignationMutation,
  useRenameDesignationMutation,
  useDeleteDesignationMutation,
  useAssignDesignationPermissionMutation,
  useRemoveDesignationPermissionMutation,
} = designationsApi;
